import React, { Fragment } from 'react';
  
  const Cant_See_Screen = ({
    isMobile
  }) =>  {
    return (
        <Fragment>
              
            {/* Heading */}
            <div style={{paddingBottom: '2rem', marginBottom: '2rem', borderBottom: '1px solid rgb(39,39,42)'}}>
                <h1 style={{fontWeight: 'bold', fontSize: '1.5rem', margin: 0}}>
                    Can't See Screen
                </h1>
                <p style={{color: 'rgb(161,161,170)', fontSize: '.875rem', marginTop: '.5rem'}}>
                    Follow these steps to resolve screen visibility issues.
                </p>
            </div>
            {/* Main content */}
            <div>
                {/* Box Section */}
                <div style={{padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
                    {/* Box Title */}
                    <h2 style={{color: 'rgb(228,228,231)', fontWeight: 500, fontSize: '1rem', margin: 0}}>
                        Troubleshooting Steps
                    </h2>
                    {/* Numbered List */}
                    <div style={{margin: '1rem 0'}}>
                        {/* Numbered List Item */}
                        <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', marginTop: '.75rem'}}>
                            {/* Number Circle */}
                            <div style={{borderRadius: '50%', border: '1px solid rgb(63,63,70)', fontSize: '.75rem', width: '1.5rem', height: '1.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                1
                            </div>
                            {/* Text Container */}
                            <div>
                                <p style={{color: '#fff', fontSize: '1rem', margin: '0'}}>
                                    Press CTRL + B to toggle visibility
                                </p>
                                <p style={{color: 'rgb(161,161,170)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '.25rem 0 0'}}>
                                    Your application might be hidden, press CTRL + B to toggle visibility
                                </p>
                            </div>
                        </div>
                        {/* Numbered List Item */}
                        <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', marginTop: '.75rem'}}>
                            {/* Number Circle */}
                            <div style={{borderRadius: '50%', border: '1px solid rgb(63,63,70)', fontSize: '.75rem', width: '1.5rem', height: '1.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                2
                            </div>
                            {/* Text Container */}
                            <div>
                                <p style={{color: '#fff', fontSize: '1rem', margin: '0'}}>
                                    Uninstall and reinstall the app using the link below.
                                </p>
                                <p style={{color: 'rgb(161,161,170)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '.25rem 0 0'}}>
                                    Sometimes a simple refresh can fix display issues
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
  }
  
  export default Cant_See_Screen;
  